//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
let d=[[[0,"CoarsePrecision",1,0],[0,"Direction",1,0],[0,"FinePrecision",1,0],[0,"InitialValue",1,0],[0,"JerkLimit",1,0],[0,"JumpVelocity",1,0],[0,"Junction",1,"SIM.KinematicJunction",0],[0,"Kv",1,0],[0,"Limit",1,1],[0,"LowerLimit",1,0],[0,"LowerSoftLimit",1,0],[0,"MaxAcceleration",1,0],[0,"MaxDeceleration",1,0],[0,"MaximumSpindleSpeed",1,0],[0,"MaximumVelocity",1,0],[0,"Name",1,0],[0,"Number",1,0],[0,"Type",1,0],[0,"UpperLimit",1,0],[0,"UpperSoftLimit",1,0]],[],[]];
SPLM.SIM.KinematicAxisBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.KinematicAxisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.KinematicAxisBuilder.AxisDirectionType = Object.freeze({
    "PositiveX" : "PositiveX", "NegativeX" : "NegativeX", "PositiveY" : "PositiveY", "NegativeY" : "NegativeY", "PositiveZ" : "PositiveZ", "NegativeZ" : "NegativeZ"});

SPLM.SIM.KinematicAxisBuilder.AxisMotionType = Object.freeze({
    "LinearNcAxis" : "LinearNcAxis", "RotaryNcAxis" : "RotaryNcAxis", "Linear" : "Linear", "Rotary" : "Rotary", "RotaryUnlimitedNcAxis" : "RotaryUnlimitedNcAxis", "SpindleNcAxis" : "SpindleNcAxis", "RotaryUnlimited" : "RotaryUnlimited", "Spindle" : "Spindle"});

export default SPLM;